export const BottomTab = ({ children }) => <div
  className='w-full flex flex-col bg-light border border-secondary border-t-2 border-b-0 border-x-0 border-dashed p-10 pt-7 space-y-2 rounded-b-3xl'
  style={{
    // boxShadow: 'inset 0px -2px 4px #B8C9FB'
    boxShadow: 'inset 0px -2px 4px #17171711'
  }}
>
  {children}
</div>;